import { connect } from "react-redux";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";
import {
    getActiveEnvironmentMoniker,
    getAppRegistrations,
} from "store/environments/environment-selectors";
import { RootState } from "store/store";
import ErpConnectionInfo from "./ErpConnectionInfo";
import { fetchDooapAppRegistrationsWithoutLoader as fetchDooapAppRegistrations } from "store/environments/environment-thunks";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        appRegistrations: getAppRegistrations(state),
    };
};

const ErpConnectionInfoContainer = connect(mapStateToProps, {
    fetchDooapAppRegistrations,
    setIsUnsavedChangeAvailable,
})(ErpConnectionInfo);

export default ErpConnectionInfoContainer;
